
import React,{useEffect,useState}from"react";
import{Box,useMediaQuery}from"@mui/material";
import{useTheme}from"@mui/material/styles";
import{useSearchParams}from"react-router-dom";
import Sidebar from"./Sidebar";
import TopBar from"./TopBar";
import{useDashboardTheme}from"../../../context/DashboardThemeContext";
import ThemeColors from"./Configurations/ThemeSettings";
import PermissionsConfig from"./Configurations/PermissionsSettings";

const SIDEBAR_EVENT="yumim:sidebar-change";
const SIDEBAR_STATE_KEY="__yumimDesktopSidebarOpen";

function getDesktopSidebarOpen(){
  if(typeof window==="undefined")return true;

  if(typeof window[SIDEBAR_STATE_KEY]!=="boolean"){
    window[SIDEBAR_STATE_KEY]=true;
  }

  return window[SIDEBAR_STATE_KEY];
}

function updateDesktopSidebarOpen(value){
  if(typeof window==="undefined")return;

  const current=getDesktopSidebarOpen();
  const next=typeof value==="function"
    ?Boolean(value(current))
    :Boolean(value);

  if(current===next)return;

  window[SIDEBAR_STATE_KEY]=next;
  window.dispatchEvent(new Event(SIDEBAR_EVENT));
}

export default function Configurations(){
  const muiTheme=useTheme();
  const isMobile=useMediaQuery(muiTheme.breakpoints.down("md"));
  const{dashboardTheme}=useDashboardTheme();
  const[desktopOpen,setDesktopOpen]=useState(getDesktopSidebarOpen);
  const[mobileOpen,setMobileOpen]=useState(false);
  const[searchParams]=useSearchParams();

  const section=searchParams.get("section")||"appearance";
  const sidebarOpen=isMobile?mobileOpen:desktopOpen;

  useEffect(()=>{
    const syncSidebar=()=>{
      setDesktopOpen(getDesktopSidebarOpen());
    };

    window.addEventListener(SIDEBAR_EVENT,syncSidebar);
    syncSidebar();

    return()=>{
      window.removeEventListener(SIDEBAR_EVENT,syncSidebar);
    };
  },[]);

  const handleToggleSidebar=()=>{
    if(isMobile){
      setMobileOpen(previous=>!previous);
      return;
    }

    updateDesktopSidebarOpen(previous=>!previous);
  };

  const handleCloseSidebar=()=>{
    if(isMobile){
      setMobileOpen(false);
      return;
    }

    updateDesktopSidebarOpen(false);
  };

  return(
    <Box
      sx={{
        minHeight:"100dvh",
        width:"100%",
        bgcolor:dashboardTheme.dashboard_background,
        display:"flex",
        color:dashboardTheme.text_color,
        overflowX:"hidden"
      }}
    >
      <Sidebar
        open={sidebarOpen}
        onClose={handleCloseSidebar}
      />

      <Box
        sx={{
          flex:1,
          minWidth:0,
          minHeight:"100dvh",
          display:"flex",
          flexDirection:"column"
        }}
      >
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={handleToggleSidebar}
        />

        <Box
          component="main"
          sx={{
            flex:1,
            minWidth:0,
            width:"100%",
            boxSizing:"border-box",
            p:{xs:2,md:3}
          }}
        >
          {section==="access"
            ?<PermissionsConfig/>
            :<ThemeColors/>
          }
        </Box>
      </Box>
    </Box>
  );
}
